import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "DotsHorizontal",
  "use": "DotsHorizontal-usage",
  "viewBox": "0 0 36 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 8\" id=\"DotsHorizontal\"><path fill-rule=\"evenodd\" d=\"M36 0v7.5h-7.5V0H36zM21.75 0v7.5h-7.5V0h7.5zM7.5 0v7.5H0V0h7.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol